import HASONBASHO from 'src/consts/hasonbasho'
import baseApi from 'src/apis/base'
import poleApi from 'src/apis/pole'
import jointApi from 'src/apis/joint'
import emergencyTelApi from 'src/apis/emergency_tel'

export default {
  methods: {
    _getPiers(dataArr, mode = null) {
      const ret = {
        shikyakuNo: null,
        shuukyakuNo: null,
        errorMsg: null,
      }

      // 始脚番号, 終脚番号を取得できなかった場合はエラー
      if (!dataArr || dataArr.length === 0) {
        ret.errorMsg = '橋脚番号は取得できませんでした'
        return ret
      }
      // 始脚番号, 終脚番号を複数取得した場合はエラー
      if (dataArr.length > 1) {
        ret.errorMsg = '橋脚番号は一意に取得できませんでした'
        return ret
      }

      // 始脚番号, 終脚番号を一意に取得した場合
      const data = dataArr[0]
      if (mode === 'joint') {
        ret.shikyakuNo = data.pier_no
      } else {
        ret.shikyakuNo = data.start_pier
        ret.shuukyakuNo = data.end_pier
      }

      return ret
    },
    async getPiersByPole(poleNo, rosenNameKodan) {
      // ポール照明台帳から公団用路線名, ポール番号をもとに始脚番号, 終脚番号を取得する
      const reqObj = {
        route_name: rosenNameKodan,
        pole_no_input_format: poleNo,
      }
      const { data } = await poleApi.index(reqObj)

      return this._getPiers(data)
    },
    async getPiersByJoint(jointNo, rosenNameKodan) {
      // 伸縮継手台帳から公団用路線名, 伸縮継手番号をもとに橋脚番号を取得する
      const reqObj = {
        route_name: rosenNameKodan,
        joint_no_input_format: jointNo,
      }
      const { data } = await jointApi.index(reqObj)

      return this._getPiers(data, 'joint')
    },
    async getPiersByKilopost(kp, rosenNameKodan, rosenHoukouName, honsenranpuKubunName) {
      let kpStr = ''
      let kpNum = null

      let str = kp.toString()
      // マイナスの形式を台帳形式に変換
      str = str.replace('(-)', '（-）')
      // 「（-）」を「-」に変換
      str = str.replace('（-）', '-')

      // FIXME キロポストを文字列部分と数値部分とに分解する
      const m = str.match(/(^[^0-9-]*?)([0-9-]+(\.|\+)*[0-9.]*[0-9+.]*)/)
      if (m) {
        kpStr = m[1]
        kpNum = m[2]
        // 数値変換
        kpNum = parseFloat(kpNum)
        if (isNaN(kpNum)) {
          // 数値に変換できない場合
          kpNum = null
        }
      }

      // 基本台帳から公団用路線名, 路線方向, キロポスト, 本線ランプ区分をもとに始脚番号, 終脚番号を取得する
      const reqObj = {
        route_name: rosenNameKodan,
        direction_name: rosenHoukouName,
        start_kp_input_format: kpStr,
        mainline_ramp_input_format: honsenranpuKubunName,
        kp: kpNum,
      }
      const { data } = await baseApi.index(reqObj)

      return this._getPiers(data)
    },
    async getPiersByEmergencyTel(emergencyTelNo, rosenNameKodan, rosenHoukouName) {
      // 非常電話台帳から公団用路線名, 非常電話番号をもとにキロポストを取得する
      const reqObj = {
        route_name: rosenNameKodan,
        emergency_tel_no_input_format: emergencyTelNo,
      }
      const { data: emergencyTels } = await emergencyTelApi.index(reqObj)

      let bases = []
      // 非常電話台帳からキロポストを一意に取得できた場合
      if (emergencyTels !== null && emergencyTels.length === 1) {
        // 基本台帳から公団用路線名, 路線方向, キロポストをもとに始脚番号, 終脚番号を取得する。
        const reqObj = {
          route_name: rosenNameKodan,
          direction_name: rosenHoukouName,
          kp: emergencyTels[0].kp,
        }
        const { data } = await baseApi.index(reqObj)
        bases = data
      }

      // 基本台帳から２件取得した場合
      if (bases != null && bases.length === 2) {
        // 優先度に基づき対象レコードを設定する　
        const [base1, base2] = bases
        // 始脚側距離標と終脚側距離標が一致する場合
        if (base1.min_kp === base2.max_kp || base2.min_kp === base1.max_kp) {
          const kp = emergencyTels[0].kp
          let base
          // 始脚側距離標が非常電話のKPより大きい場合
          if (base1.min_kp >= kp) {
            base = base1
          } else if (base2.min_kp >= kp) {
            base = base2
          }
          bases = [base]
        }
      }

      return this._getPiers(bases)
    },
    _convHasonbashoNo(hasonbashoNo) {
      let str = hasonbashoNo

      // 全角を半角に変換
      str = str.replace(/[Ａ-Ｚａ-ｚ０-９－（）．]/g, s => {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      })

      return str
    },
    async getPiersByHasonbasho({ hasonbashoId, hasonbashoNo, rosenNameKodan, rosenHoukouName, honsenranpuKubunName }) {
      let ret = this._getPiers()

      hasonbashoId = parseInt(hasonbashoId)
      if (isNaN(hasonbashoId)) { return ret }
      hasonbashoNo = this._convHasonbashoNo(hasonbashoNo)
      if (hasonbashoNo === null || hasonbashoNo === undefined || hasonbashoNo === '') { return ret }

      if (hasonbashoId === HASONBASHO.POLE) {
        ret = await this.getPiersByPole(hasonbashoNo, rosenNameKodan)
      } else if (hasonbashoId === HASONBASHO.JOINT) {
        ret = await this.getPiersByJoint(hasonbashoNo, rosenNameKodan)
      } else if (hasonbashoId === HASONBASHO.KP) {
        ret = await this.getPiersByKilopost(hasonbashoNo, rosenNameKodan, rosenHoukouName, honsenranpuKubunName)
      } else if (HASONBASHO.EMERGENCY_TELS.findIndex(e => e === hasonbashoId) !== -1) {
        ret = await this.getPiersByEmergencyTel(hasonbashoNo, rosenNameKodan, rosenHoukouName)
      }

      return ret
    },
  }
}
